<template>
  <ve-histogram
    :data="chartData"
    :settings="settings"
    :extend="chartExtends"
    :title="titleText"
    :legend="extend.legend"
    :tooltip="extend.tooltip"
    :yAxis="chartExtends.yAxis"
    :events="chartEvents"
    :colors="colors"
    :data-empty="!chartData.rows"
    ref="chartP"
  ></ve-histogram>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import { _ } from "vue-underscore";
import VCharts from "v-charts";
Vue.use(VCharts);
export default {
  name: "chartPayment",
  props: [
    "chartData",
    "dataEmpty",
    "titleText",
    "collapsed",
    "request",
    "showToolbox",
    "currency"
  ],
  data() {
    var self = this;
    this.chartEvents = {
      click: e => {
        this.changeData(e.name);
      }
    };
    this.chartExtends = {
      grid: {
        left: "20px",
        right: "20px",
        top: "100px",
        bottom: "0px",
        containLabel: true
      },
      title: {
        padding: [0, 0, 0, 0],
        textStyle: {
          fontFamily: "Avenir, Roboto, sans-serif"
        }
      },
      toolbox: {
        show: this.showToolbox,
        left: 0,
        feature: {
          myTool1: {
            show: true,
            showTitle: false,
            title: " ",
            itemSize: 40,
            icon:
              "path://M420.361,192.229c-1.83-0.297-3.682-0.434-5.535-0.41H99.305l6.88-3.2c6.725-3.183,12.843-7.515,18.08-12.8l88.48-88.48 c11.653-11.124,13.611-29.019,4.64-42.4c-10.441-14.259-30.464-17.355-44.724-6.914c-1.152,0.844-2.247,1.764-3.276,2.754 l-160,160C-3.119,213.269-3.13,233.53,9.36,246.034c0.008,0.008,0.017,0.017,0.025,0.025l160,160 c12.514,12.479,32.775,12.451,45.255-0.063c0.982-0.985,1.899-2.033,2.745-3.137c8.971-13.381,7.013-31.276-4.64-42.4 l-88.32-88.64c-4.695-4.7-10.093-8.641-16-11.68l-9.6-4.32h314.24c16.347,0.607,30.689-10.812,33.76-26.88 C449.654,211.494,437.806,195.059,420.361,192.229z",
            iconStyle: {
              color: "#000000",
              borderWidth: 0
            },
            onclick: () => {
              let today, day, start, end;

              today = moment().utc();
              day = moment(this.request.date_range[0]).utc();
              start = day
                .startOf("month")
                .startOf("day")
                .format("YYYY-MM-DDTHH:mm:ss.000000");

              if (today.isBefore(day.endOf("month").endOf("day"))) {
                end = today.endOf("day").format("YYYY-MM-DDTHH:mm:ss.000000");
              } else {
                end = day
                  .endOf("month")
                  .endOf("day")
                  .format("YYYY-MM-DDTHH:mm:ss.000000");
              }

              this.$emit(
                "loadAsyncData",
                _.extend(this.request, {
                  date_range: [start, end],
                  period: "daily"
                })
              );
              this.$emit("clearData");
            }
          }
        }
      },
      xAxis: {
        axisPointer: {
          type: "line",
          lineStyle: {
            color: "#000000",
            opacity: 0.25,
            width: 2,
            type: "dashed"
          }
        },
        axisLabel: {
          padding: [10, 0, 0, 0],
          formatter: function(value, index) {
            let date = new Date(value),
              d = date.getDate().toString(),
              m = (date.getMonth() + 1).toString(),
              text_d = d.length < 2 ? "0" + d : d,
              text_m = m.length < 2 ? "0" + m : m;
            return text_d + "/" + text_m;
          }
        }
      },
      yAxis: [
        {
          type: "value",
          show: true,
          axisLabel: {
            formatter: function(value, index) {
              let q = (value / 100).toFixed(0);
              return q.toString().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, "$1 ");
            },
            textStyle: {
              fontStyle: "normal",
              fontSize: 12,
              fontFamily: "Avenir, Roboto, sans-serif",
              fontWeight: 500
            }
          }
        },
        {
          type: "value",
          min: 0,
          max: 100,
          position: "right",
          axisLabel: {
            formatter: "{value} %"
          },
          textStyle: {
            fontStyle: "normal",
            fontSize: 12,
            fontFamily: "Avenir, Roboto, sans-serif",
            fontWeight: 500
          }
        }
      ],
      series(v) {
        v.forEach(i => {
          if (i.type == "line") {
            i.symbolSize = 8;
            i.yAxisIndex = 1;
            i.smooth = 0;
            i.lineStyle = {
              width: 3,
              shadowColor: "rgba(0, 0, 0, 0.15)",
              shadowBlur: 7,
              shadowOffsetY: 10
            };
            i.itemStyle = {
              borderWidth: 2
            };
          } else {
            i.barMaxWidth = 50;
            i.itemStyle = {
              barBorderRadius: [5, 5, 0, 0]
            };
            i.label = {
              normal: {
                show: false
              }
            };
          }
        });
        return v;
      }
    };
    return {
      newRequest: {},
      seriesName: {
        successful_amount: "Успешные",
        fail_amount: "Неуспешные",
        conversion: "Конверсия"
      },
      extend: {
        tooltip: {
          trigger: "axis",
          formatter: (params, ticket, callback) => {
            let str = "";
            let date = "";

            let name = params[0].name || "";
            if (name != "") {
              let fullDate = new Date(name),
                d = fullDate.getDate(),
                m = fullDate.getMonth() + 1,
                y = fullDate.getFullYear(),
                text_d = d < 10 ? "0" + d.toString() : d.toString(),
                text_m = m < 10 ? "0" + m.toString() : m.toString();

              date = text_d + "." + text_m + "." + y + "<br>";
            }

            let text = params
              .map(el => {
                let val =
                  el.seriesName == "conversion"
                    ? el.value.toFixed(2) + "%"
                    : this.prettyAmount(el.value / 100) + " " + this.currency;

                let timestamp = this.chartData.rows.find(
                  i => i.timestamp == el.name
                );

                let total = "";
                if (el.seriesName == "successful_amount")
                  total = timestamp.successful_total;
                if (el.seriesName == "fail_amount")
                  total = timestamp.fail_total;

                return (
                  " <span class=" +
                  el.seriesName +
                  ">" +
                  total +
                  " " +
                  this.seriesName[el.seriesName] +
                  ": " +
                  val +
                  "</span><br/>"
                );
              })
              .join("\n");

            let fullAmount = params
              .filter(el => el.seriesName != "conversion")
              .map(el => el.value)
              .reduce((a, b) => a + b);

            let full =
              "<br/>Всего: " + this.prettyAmount(fullAmount / 100) + " " + this.currency + "<br/>";

            let day = this.chartData.rows.find(
              el => el.timestamp == params[0].name
            );

            let fullTotal = day.successful_total + day.fail_total;

            let avg =
              "Средний чек: " +
              this.prettyAmount(fullAmount / 100 / fullTotal) +
              " " + this.currency;

            str = date + text + full + avg;

            return str;
          },
          backgroundColor: "#383054",
          padding: [15, 20],
          textStyle: {
            fontStyle: "normal",
            fontSize: 12,
            fontFamily: "Roboto, sans-serif",
            fontWeight: 400
          }
        },
        legend: {
          selectedMode: "multiple",
          align: "left",
          icon: "circle",
          right: 0,
          top: 0,
          formatter: name => {
            if (this.seriesName.hasOwnProperty(name))
              return this.seriesName[name];
            return name;
          }
        },
        series: {
          label: {
            normal: {
              show: false
            }
          },
          labelLine: {
            normal: {
              show: false
            }
          }
        }
      },
      settings: {
        dimension: ["timestamp"],
        metrics: ["successful_amount", "fail_amount", "conversion"],
        showLine: ["conversion"]
      },
      colors: ["#18c36f", "#c61b57", "#f0854c"]
    };
  },
  methods: {
    changeData(name) {
      this.newRequest = { ...this.request };
      let start = moment(name)
        .utc()
        .startOf("day")
        .format("YYYY-MM-DDTHH:mm:ss.000000");
      let end = moment(name)
        .utc()
        .endOf("day")
        .format("YYYY-MM-DDTHH:mm:ss.000000");
      this.$emit(
        "loadAsyncData",
        _.extend(this.request, { period: "hourly", date_range: [start, end] })
      );
      this.$emit("clearData");
    },
    prettyAmount(value) {
      if (!value) return "0.00";
      return value.toFixed(2).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, "$1 ");
    }
  },
  watch: {
    collapsed(v) {
      setTimeout(() => {
        this.$refs.chartP.resize();
      }, 500);
    }
  },
  computed: {}
};
</script>

<style></style>
